import ApiService from "@/core/services/api.service";

// action types
export const FETCH_ADMIN_LIVES = "fetchAdminLives";

// mutation types
export const SET_ADMIN_LIVES = "setAdminLives";
export const SET_ADMIN_LIVES_PAGINATION = "setAdminLivesPagination";

const state = {
  adminLives: [],
  adminLivesPagination: {
    total: 0,
    currentPage: 1,
    firstPage: 1,
    lastPage: 1,
    perPage: 0
  }
};

const getters = {
  adminLives(state) {
    return state.adminLives;
  },
  adminLivesPagination(state) {
    return state.adminLivesPagination;
  }
};

const actions = {
  [FETCH_ADMIN_LIVES](context, payload) {
    let params = {
      page: context.state.adminLivesPagination.currentPage
    };
    if (payload.status !== undefined) {
      params.status = payload.status;
    }
    if (payload.from) {
      params.from = payload.from || new Date();
    }

    return new Promise((resolve, reject) => {
      ApiService.query("admin/lives", {
        params: params
      })
        .then(({ data }) => {
          context.commit(SET_ADMIN_LIVES, data.data);
          context.commit(SET_ADMIN_LIVES_PAGINATION, {
            total: data["total"],
            currentPage: data["current_page"],
            firstPage: data["first_page"],
            lastPage: data["last_page"],
            perPage: data["per_page"]
          });
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }
};

const mutations = {
  [SET_ADMIN_LIVES](state, payload) {
    state.adminLives = payload;
  },
  [SET_ADMIN_LIVES_PAGINATION](state, data) {
    state.adminLivesPagination = data;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
